// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_kp-1";
export var rowFirst = "_kp-3";
export var rowLast = "_kp-5";
export var rowMiddle = "_kp-4";
export var ticketListScroll = "_kp-2";
export var ticketStack = "_kp-0";